// Pure helpers for A2-board + video media, shared by the admin (EntryDetail)
// and entrant (SubmitChange) entry views. Kept out of the component file so
// the preview components can live behind React Fast Refresh cleanly.

export interface A2Board {
  label: string;
  url: string;
}

/** Build the list of populated A2 boards from a nomination. Empty slots drop
 *  out so the preview only shows boards that actually have a URL. */
export function a2BoardsFrom(nom: { a2board1?: string | null; a2board2?: string | null }): A2Board[] {
  const out: A2Board[] = [];
  if (nom.a2board1) out.push({ label: 'A2 Board 1', url: nom.a2board1 });
  if (nom.a2board2) out.push({ label: 'A2 Board 2', url: nom.a2board2 });
  return out;
}

/** Turn a YouTube watch/shorts/youtu.be URL into an embeddable /embed/ URL, or
 *  null if it isn't a recognisable YouTube link (caller falls back to a plain
 *  anchor). */
export function youtubeEmbed(url: string): string | null {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}
